export class MasterPlanType {
    id!: number;
    name!: string;
}